var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultLayout',[_c('div',{staticClass:"row text-center pt-5"},[_c('div',{staticClass:"col-md-4 offset-4 pt-5"},[_c('a',{staticClass:"btn btn-primary btn-md",attrs:{"href":"#"},on:{"click":_vm.contactNow}},[_vm._v(_vm._s(_vm.$t('Contact.click-here-to-contact-us')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }